import React, {ReactElement} from "react";
import {Slider, Typography} from "@mui/material";
import {ImageAttributes, PageElement, PageElementType} from "@/smilebook-shared/types";
import {StyledBoxColumn, StyledBoxRowWithLabel} from "../../shared/StyledComponents";

export function SidebarContentImage(props: {
  selectedElement: PageElement,
  selectedImageAttributes: ImageAttributes,
  setSelectedImageAttributes: (attributes: ImageAttributes) => void
}): ReactElement {
  return props.selectedElement?.type === PageElementType.IMAGE
    ? <StyledBoxColumn>
      <StyledBoxRowWithLabel label={"Scale"}>
        <Slider
          marks={true}
          min={1}
          max={2}
          step={0.05}
          value={props.selectedImageAttributes?.scale || 1}
          onChange={(e, value: number) => {
            props.setSelectedImageAttributes(Object.assign(props.selectedImageAttributes || new ImageAttributes(), {scale: value}));
          }}/>
      </StyledBoxRowWithLabel>
    </StyledBoxColumn>
    : <Typography>No element selected, or selected element is not an image.</Typography>
}